import { api_get, api_post, stringfy_post } from './../../../utils/http'

const baseUri = '/search/api'

/**
 * 1.查询教材系列
 */
function bookSeries(params: any) {
  return api_post(baseUri + '/book/series', params)
}

function bookCatalog(params: any) {
  return api_post(baseUri + '/book/catalog', params)
}

function knowledgeManage(params: any) {
  return api_post(baseUri + '/knowledge_point/knowledge_point_manage', params)
}

function getBooks(params: any) {
  return api_post(baseUri + '/book/get_books', params)
}

function questionList(params: any) {
  return stringfy_post(baseUri + '/question/list', params)
}

function questionDetail(params: any) {
  return api_get(baseUri + '/question/detail', params)
}

function getQuestionCart(params: any) {
  return api_post(baseUri + '/question_cart/get_question_cart', params)
}

function updateQuestionCart(params: any) {
  return stringfy_post(baseUri + '/question_cart/create_or_update', params)
}

function addQuestionToCart(params: any) {
  return api_post(baseUri + '/question_cart/add_question', params)
}

function removeUestionFromCart(params: any) {
  return api_post(baseUri + '/question_cart/remove_question', params)
}

function getQuestionBase(params: any) {
  return api_get(baseUri + '/question/', params)
}
/**
 * 7.基本信息
 */
function getInitInfo(params: any) {
  return api_get(baseUri + '/question/', params)
}
/**
 * 8.剩余下载券总数
 */
function couponNum(params: any) {
  return api_get(baseUri + '/personal/membership/coupon-num', params)
}

function downloadPaper(params: any) {
  return api_post(baseUri + '/question_cart/download_paper', params)
}

function listDetail(params: any) {
  return api_get(baseUri + '/question_cart/list_detail', params)
}

function setTitle(params: any) {
  return api_post(baseUri + '/question_cart/set_title', params)
}

function recordBook(params: any) {
  return api_post(baseUri + '/book/record_book', params)
}
// 拍搜接口
function searchQuestions(params: any) {
  return api_post(baseUri + '/question/photo-search', params)
}
// 相似题获取接口
function similarSearch(params: any) {
  return api_post(baseUri + '/question/similar-search', params)
}
// 相似题获取接口
function switchQuestion(params: any) {
  return api_post(baseUri + '/question_cart/switch_question', params)
}
// 获取剩余下载券、价格
function getDownloadInfo(params: any) {
  return api_post(baseUri + '/question_cart/get_download_info', params)
}
// 试卷同步接口
function syncPaper(params: any) {
  return api_post(baseUri + '/question_cart/sync_paper', params)
}
export {
  bookSeries,
  bookCatalog,
  knowledgeManage,
  getBooks,
  questionList,
  getQuestionCart,
  updateQuestionCart,
  addQuestionToCart,
  removeUestionFromCart,
  getQuestionBase,
  getInitInfo,
  questionDetail,
  couponNum,
  downloadPaper,
  listDetail,
  setTitle,
  recordBook,
  searchQuestions,
  similarSearch,
  switchQuestion,
  getDownloadInfo,
  syncPaper
}
